import React from "react";
import Footer from "../../../../../components/Footer";
import VerifyVoucher from "../../../../../components/VerifyVoucher";

const WarningVoucherFooter = ({
  isShowWarningVoucher = false,
  isShowWarningRedeem = false,
  dataVoucherWarning = null,
  handleUpdateVoucherList = () => {},
  setDataVoucherWarning = () => {},
  setIsShowWarningVoucher = () => {},
  handleVerifyRedeemVoucherGLobal = () => {}
}) => {
  return (
    <>
      {isShowWarningVoucher && (
        <Footer position="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl" id="verify-voucher" className={`h-full`}>
          <VerifyVoucher
            onSubmit={() => {
              console.log("onSubmit");
              handleUpdateVoucherList(
                dataVoucherWarning?.code,
                dataVoucherWarning?.voucher_type,
                dataVoucherWarning?.is_use,
                dataVoucherWarning?.type
              );
              setIsShowWarningVoucher(false);
            }}
            onCancel={() => {
              console.log("onCancel");
              setDataVoucherWarning(null);
              setIsShowWarningVoucher(false);
            }}
          />
        </Footer>
      )}
      {isShowWarningRedeem && (
        <Footer position="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl" id="verify-voucher" className={`h-full`}>
          <VerifyVoucher
            onSubmit={() => {
              console.log("onSubmit");
              handleVerifyRedeemVoucherGLobal(true);
            }}
            onCancel={() => {
              console.log("onCancel");
              handleVerifyRedeemVoucherGLobal(false);
            }}
            title="Apakah anda yakin ingin menggunakan voucher ini ?"
          />
        </Footer>
      )}
    </>
  );
};

export default WarningVoucherFooter;
